import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *{
    margin:0;
    padding:0;
    outline:0;
    box-sizing:border-box;
    -webkit-font-smoothing: antialiased;

  }

  :root{
    --white:#ffffff;
    --background-gray:#F2F5F7;
    --gray-line: #C2D1D9;
    --orange: #EB5E35;
    --aside-background:#EBF1F4;
    --soft-orange:#FFE5CB;
    --orange-gradient:linear-gradient(180deg, #F79765 0%, #EB5E35 100%);
    --purple: #3F1159;
    --purple-ligth: #482A73;
    --purple2:#4C1D6B;
    --purple3:#4D1D6E;
    --text:#7E8B92;
    --title-higlight:#505D68;
    --red:#E83f5b;
    --red2:#d61737;
    --green:#499D45;
    --yellow:#dca62c;
    --transparent:transparent;
    --box-shadow:0px 2px 1px -1px rgb(0 0 0 / 20%),
            0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);

  }

  @media(max-width: 1080px){
    html {
      font-size:93.75%;
    }
  }

  @media(max-width: 720px){
    html {
      font-size:81.45%;
    }
  }

  body{
    background:var(--white);
    color:var(--text);
    -webkit-font-smoothing: antialiased;
  }

  body,input,text-area,button{
    font: 400 1rem "Source Sans Pro", sans-serif;
  }

  button {
    cursor:pointer;
    border:0;
  }

  a{
    text-decoration:none;
    color:inherit;
  }

  h1{
    font: 700 2rem "Roboto Slab", sans-serif;
  }
`;
